/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useSubheader } from "../../../_metronic/layout";
import {
  RestlessTable,
  RestlessButtonFormatter,
  RestlessInteractionsFormatter,
} from "../../../_metronic/layout/components/Table";
import { useDispatch, useSelector } from "react-redux";
import { fetchDraftPosts, fetchPosts, hidePost } from "../../../redux/actions/posts";
import RestlessDateFormatter from "../../../_metronic/layout/components/Table/RestlessDateFormatter";
import RestlessTypeFormatter from "../../../_metronic/layout/components/Table/RestlessTypeFormatter";
import RestlessBooleanFormatter from "../../../_metronic/layout/components/Table/RestlessBooleanFormattear";
import RestlessCategoryFormatter from "../../../_metronic/layout/components/Table/RestlessCategoryFormatter";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { Route, Switch } from "react-router-dom";
import PostsDetailsDialog from "./RestlessPostsDialog/PostsDetailsDialog";
import { fetchImageToken } from "../../../redux/actions/imageAuth";
import RestlessModerationModal from "../../../_metronic/layout/components/modeationModal/RestlessModerationModal";
import {
  disabledUser,
  kickedUser,
  promoteToAdmin,
  promoteToVerified,
  reenableUser,
  shadowbanUser,
} from "../../../redux/actions/users";
import { Alert } from "react-bootstrap";
import { postsSlice } from "../../../redux/actions/posts/postsSlice";
import { Tabs, Tab } from "react-bootstrap";
import DeletePostDialog from "./RestlessPostEditor/DeletePostDialog";
import RestlessBodyContentFormatter from "../../../_metronic/layout/components/Table/RestlessBodyContentFormatter";
import RestlessBodyContentSubstr from "../../../_metronic/layout/components/Table/RestlessBodyContentSubstr";

const { actions } = postsSlice;

export default function RestlessPostsPage({ history }) {
  const suhbeader = useSubheader();
  suhbeader.setTitle("Posts");
  const [newPostCreated, setNewPostCreated] = useState();
  const [postEdited, setPostEdited] = useState();
  const [activeTab, setActiveTab] = useState();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchImageToken());
    dispatch(fetchPosts());
    dispatch(fetchDraftPosts());
    dispatch(actions.getPost({ fetchPost: null }));
  }, []);

  const {
    posts,
    listLoading,
    hideLoading,
    postHided,
    error,
    newPost,
    postDraftEdited,
    postDeleted,
    drafPost,
  } = useSelector((state) => ({
    posts: state.posts.postsList,
    listLoading: state.posts.listLoading,
    hideLoading: state.posts.hideLoading,
    postHided: state.posts.postHided,
    error: state.posts.error,
    newPost: state.posts.newPost,
    postDraftEdited: state.posts.postDraftEdited,
    postDeleted: state.posts.postDeleted,
    drafPost: state.posts.drafPost,
  }));

  const onClose = () => {
    setNewPostCreated();
    setPostEdited();
  };

  useEffect(() => {
    if (newPost) {
      dispatch(actions.postCreated({ newPost: null }));
      setNewPostCreated("Your post was created successfully");
    }
    if (postDraftEdited) {
      dispatch(actions.getPost({ fetchPost: null}));
      dispatch(actions.postDraftEdited({ postDraftEdited: null }));
      setPostEdited("Your post was edited successfully");
    }
    if (postDeleted) {
      dispatch(actions.deletePost({ postDeleted: null }));
      setPostEdited("Your post was deleted successfully");
    }
  }, [newPost, postDraftEdited, postDeleted]);

  //Array of buttons, atributes = onClickFunction, text, icon
  const buttonsArr = [
    {
      onClickFunction: (row) => {
        return schedulePostUIEvents.openEditDraftPostsDetailsDialog(row);
      },
      icon: (
        <SVG
          title="Edit"
          src={toAbsoluteUrl("/media/svg/icons/General/Edit.svg")}
        />
      ),
      disabled: true,
      postactions: true,
      title: "Edit",
    },
    {
      onClickFunction: (row) => {
        return schedulePostUIEvents.openDeleteDraftPostDialog(row);
      },
      disabled: true,
      postactions: true,
      icon: (
        <SVG
          title="Delete"
          src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}
        />
      ),
      title: "Delete",
    },
    {
      onClickFunction: (row) => {
        return postsUIEvents.openPostsDetailsDialog(row);
      },
      icon: (
        <SVG
          title="Detail"
          src={toAbsoluteUrl("/media/svg/icons/Text/Bullet-list.svg")}
        />
      ),
      title: "Detail",
    },
    {
      onClickFunction: (row) => {
        return postsUIEvents.openModeratePostsDialog(row);
      },
      disabled: true,
      icon: (
        <SVG
          title="Moderate"
          src={toAbsoluteUrl("/media/svg/icons/General/Settings-1.svg")}
        />
      ),
      title: "Moderate",
    },
  ];

  const buttonsArrSchedule = [
    {
      onClickFunction: (row) => {
        return schedulePostUIEvents.openEditDraftPostsDetailsDialog(row);
      },
      disabled: true,
      icon: (
        <SVG
          title="Edit"
          src={toAbsoluteUrl("/media/svg/icons/General/Edit.svg")}
        />
      ),
      title: "Edit",
    },
    {
      onClickFunction: (row) => {
        return schedulePostUIEvents.openDeleteDraftPostDialog(row);
      },
      disabled: true,
      icon: (
        <SVG
          title="Delete"
          src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}
        />
      ),
      title: "Delete",
    },
  ];

  //Functions to open the dialog
  const postsUIEvents = {
    openPostsDetailsDialog: (row) => {
      history.push({
        pathname: `/posts/${row.id}/details`,
        state: { row: row },
      });
    },
    openModeratePostsDialog: (row) => {
      history.push({
        pathname: `/posts/${row.id}/moderate`,
        state: { row: row },
      });
    },
    openPostCreatePage: (row) => {
      history.push({
        pathname: `/posts/new`,
      });
    },
  };

  const schedulePostUIEvents = {
    openEditDraftPostsDetailsDialog: (row) => {
      history.push({
        pathname: `/posts/editor/${row.id}`,
        state: { row: row },
      });
    },
    openDeleteDraftPostDialog: (row) => {
      history.push({
        pathname: `/posts/${row.id}/delete`,
        state: { row: row },
      });
    },
    openPostCreatePage: (row) => {
      history.push({
        pathname: `/posts/new`,
      });
    },
  };

  const columns = [
    {
      dataField: "restless_user.full_name",
      text: "Author",
      sort: true,
    },
    {
      dataField: "id",
      text: "ID",
      sort: true,
    },
    {
      dataField: "published_at",
      text: "Created",
      sort: true,
      formatter: RestlessDateFormatter,
    },
    {
      dataField: "poll",
      text: "Type",
      sort: true,
      formatter: RestlessTypeFormatter,
    },

    {
      dataField: "category.name",
      text: "Category",
      sort: true,
      formatter: RestlessCategoryFormatter,
    },

    {
      dataField: "deleted",
      text: "Deleted",
      sort: true,
      formatter: RestlessBooleanFormatter,
    },
    {
      dataField: "views_count",
      text: "Views",
      sort: true,
      formatter: RestlessInteractionsFormatter,
    },
    {
      dataField: "reactions",
      text: "Reaction",
      sort: true,
      formatter: RestlessInteractionsFormatter,
    },
    {
      dataField: "info.comments",
      text: "Comments",
      sort: true,
      formatter: RestlessInteractionsFormatter,
    },
    {
      dataField: "reports",
      text: "Reports",
      sort: true,
      formatter: RestlessInteractionsFormatter,
    },
    {
      dataField: "action1",
      formatter: RestlessButtonFormatter,
      formatExtraData: { buttonsArr },
    },
  ];






  const columnsSchedule = [
    {
      dataField: "created_at",
      text: "Created",
      sort: true,
      formatter: RestlessDateFormatter,
    },
    {
      dataField: "id",
      text: "ID",
      sort: true,
    },
    {
      dataField: "category.name",
      text: "Category",
      sort: true,
      formatter: RestlessCategoryFormatter,
    },
    {
      dataField: "restless_user.full_name",
      text: "Author",
      sort: true,
    },
    {
      dataField: "body",
      text: "Body",
      sort: true,
      formatter: RestlessBodyContentSubstr
    },
    {
      dataField: "scheduled_dt",
      text: "Posting Date",
      sort: true,
      formatter: RestlessDateFormatter,
    },
    {
      dataField: "deleted",
      text: "Deleted",
      sort: true,
      formatter: RestlessBooleanFormatter,
    },
    {
      dataField: "action2",
      text: "Actions",
      formatter: RestlessButtonFormatter,
      formatExtraData: { buttonsArr: buttonsArrSchedule },
    },
  ];

  const onSubmit = (values, row) => {
    const user = row.restless_user ? row.restless_user : row;

    if (values.userAction === "REENABLE_ON_SELF") {
      dispatch(reenableUser({ user, reEnableOnSelf: true }));
      history.push("/users");
      return;
    }
    if (values.userAction === "REENABLE_ON_SOCIAL") {
      dispatch(reenableUser({ user, reEnableOnSocial: true }));
      history.push("/users");
      return;
    }
    if (values.moderateUser && values.userAction === "DISABLED_ON_SELF") {
      dispatch(disabledUser({ id: user.id, disableOnSelf: true }));
    }
    if (values.moderateUser && values.userAction === "DISABLED_ON_SOCIAL") {
      dispatch(disabledUser({ id: user.id, disableOnSocial: true }));
    }

    if (values.moderateUser && values.userAction === "KICKEDOUT") {
      dispatch(kickedUser(user.id));
    }

    if (values.userAction === "SHADOWBAN") {
      const data = { shadowban: true };
      dispatch(shadowbanUser(user, data));
    }
    if (values.userAction === "UNSHADOWBANNED") {
      const data = { shadowban: false };
      dispatch(shadowbanUser(user, data));
    }

    if (values.userAction === "ADMIN") {
      dispatch(promoteToAdmin(user.id));
    }

    if (values.userAction === "VERIFIED") {
      dispatch(promoteToVerified(user.id));
    }
    dispatch(hidePost(values));
    history.push("/posts");
  };

  const renderPostModerationStatus = () => {
    return (
      <Alert variant="success" className="text-center" dismissible>
        The post has been deleted succesfully
      </Alert>
    );
  };

  const renderPostModerationError = () => {
    return (
      <Alert variant="danger" className="text-center" dismissible>
        An error has occurred
      </Alert>
    );
  };

  const renderSuccessPost = (message) => {
    return (
      <Alert
        variant="success"
        className="text-center"
        dismissible
        onClose={() => onClose()}
      >
        {message}
      </Alert>
    );
  };

  return (
    <>
      {listLoading || hideLoading ? (
        <div className="d-flex justify-content-center align-content-center">
          <span className="mx-3 spinner spinner-primary"></span>
        </div>
      ) : (
        <>
          {!error && postHided && renderPostModerationStatus()}
          {error && !postHided && renderPostModerationError()}
          {newPostCreated && renderSuccessPost(newPostCreated)}
          {postEdited && renderSuccessPost(postEdited)}
          <Switch>
            <Route path="/posts/:id/details">
              {({ history, match }) => (
                <PostsDetailsDialog
                  show={match != null}
                  id={match && match.params.id}
                  row={history.location.state?.row}
                  onHide={() => {
                    history.push("/posts");
                  }}
                />
              )}
            </Route>
            <Route path="/posts/:id/moderate">
              {({ history, match }) => (
                <RestlessModerationModal
                  show={match != null}
                  id={match && match.params.id}
                  row={history.location.state?.row}
                  onSubmit={onSubmit}
                  onHide={() => {
                    history.push("/posts");
                  }}
                  entityType="Post"
                />
              )}
            </Route>
            <Route path="/posts/:id/delete">
              {({ history, match }) => (
                <DeletePostDialog
                  show={match != null}
                  id={match && match.params.id}
                  row={history.location.state?.row}
                  onSubmit={onSubmit}
                  onHide={() => {
                    history.push("/posts");
                  }}
                  activeTab={activeTab}
                  entityType="Post"
                />
              )}
            </Route>
          </Switch>

          <Tabs
            defaultActiveKey="posts"
            id="uncontrolled-tab-example"
            style={{ backgroundColor: "#EBEDF3" }}
            onSelect={(data) => {
              setActiveTab(data)
            }}
          >
            <Tab
              eventKey="posts"
              title="Posts"
              class="tabscontainer"
              style={{ backgroundColor: "#EBEDF3" }}
            >
              <RestlessTable
                data={posts}
                columns={columns}
                withPagination
                withNewButton
                newButton={{
                  onClick: postsUIEvents.openPostCreatePage,
                  text: "New Post",
                }}
              />
            </Tab>
            <Tab
              eventKey="scheduledpost"
              title="Scheduled Posts"
              style={{ backgroundColor: "#EBEDF3" }}
            >
              <RestlessTable
                data={drafPost}
                columns={columnsSchedule}
                withPagination
                withNewButton
                newButton={{
                  onClick: postsUIEvents.openPostCreatePage,
                  text: "New Post",
                }}
              />
            </Tab>
          </Tabs>
        </>
      )}
    </>
  );
}
